import { Component } from "@angular/core";
import { UserSubscriptionRowComponent } from "./user-subscription-row.component";
import { GetSubscriptionsResponse, Subscription } from "@apiserver-rest/ponder-auth-client-base";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { take } from "rxjs";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";

@Component({
    selector: "user-subscription-table",
    imports: [UserSubscriptionRowComponent, LoadingComponent],
    templateUrl: "./user-subscription-table.component.html"
})
export class UserSubscriptionTableComponent {
    public isLoading: boolean = true;
    public subscriptions: Subscription[] = [];

    public constructor(private ponderAuthClient: PonderAuthClient) {
        
    }

    public ngOnInit(): void {
        this.ponderAuthClient
            .subscriptionList()
            .pipe(take(1))
            .subscribe({
                next: (response: GetSubscriptionsResponse) => {
                    this.subscriptions = response.subscriptions ?? [];
                }
            })
            .add(() => this.isLoading = false);
    }
}